export default __webpack_public_path__ + "static/anest-Iwata-3ff35d7892a606306b251d4c93312042.png";